import {
  AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, computed, ElementRef,
  inject, viewChild,
} from '@angular/core';

import { WINDOW } from '@hglobal/common';
import { environment } from '@pt/environment';
import { UiStore } from '@pt/services';

@Component({
  standalone: false,
  selector: 'pt-logo',
  templateUrl: './logo.component.html',
  styleUrls: ['./logo.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LogoComponent implements AfterViewInit {
  readonly #window = inject(WINDOW);
  readonly #changeDetectorRef = inject(ChangeDetectorRef);
  readonly #uiStore = inject(UiStore);

  readonly svgUse = viewChild<ElementRef>('idSvgUse');
  readonly assetsHost = environment.assetsHost;
  readonly shortName = environment.shortName;
  readonly logoName = computed(() => (this.shortName === 'ta-ed'
    ? `${this.shortName}-logo${this.#uiStore.isDarkTheme() ? '-dark' : '-light'}`
    : `${this.shortName}-logo`));

  logoWidth = 0;

  ngAfterViewInit(): void {
    this.#window.queueMicrotask(() => {
      this.logoWidth = this.#calculateLogoWidth();
      this.#changeDetectorRef.markForCheck();
    });
  }

  #calculateLogoWidth(): number {
    if (this.shortName === 'ta-ed') {
      return 160;
    }
    return this.svgUse().nativeElement?.getBBox().width || 0;
  }
}
